import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "/api/v2";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Invalid verification link. Please check your email and try again.");
      return;
    }
    fetch(`${API_BASE}/auth/verify-email?token=${token}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setStatus("success");
          setMessage("Your email has been verified successfully!");
          setTimeout(() => navigate("/login"), 3000);
        } else {
          setStatus("error");
          setMessage(data.message || "Verification failed. Link may have expired.");
        }
      })
      .catch(() => {
        setStatus("error");
        setMessage("Something went wrong. Please try again.");
      });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="ZoomPay" style={{height: "90px", width: "auto", margin: "0 auto"}} />
        </div>
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {status === "verifying" && (
            <>
              <div className="text-5xl mb-4">⏳</div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Verifying your email...</h2>
              <p className="text-gray-500 text-sm">Please wait a moment.</p>
            </>
          )}
          {status === "success" && (
            <>
              <div className="text-5xl mb-4">✅</div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Email Verified!</h2>
              <p className="text-gray-500 text-sm mb-4">{message}</p>
              <p className="text-blue-500 text-sm">Redirecting to login in 3 seconds...</p>
              <button onClick={() => navigate("/login")}
                className="mt-4 w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition">
                Go to Login
              </button>
            </>
          )}
          {status === "error" && (
            <>
              <div className="text-5xl mb-4">❌</div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Verification Failed</h2>
              <p className="text-gray-500 text-sm mb-4">{message}</p>
              <button onClick={() => navigate("/login")}
                className="mt-2 w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition">
                Back to Login
              </button>
              <button onClick={() => navigate("/register")}
                className="mt-2 w-full py-3 border border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition">
                Register Again
              </button>
            </>
          )}
        </div>
        <p className="text-center text-blue-400 text-xs mt-6">FINTRAC MSB C10001588 · ZoomPay Systems & Technology Ltd.</p>
      </div>
    </div>
  );
}
